import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCouponH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.5 40.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M30.5 28.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M60 12.75c2.9 0 5.25 2.35 5.25 5.25v11.99a2.26 2.26 0 0 1-2.257 2.26 3.75 3.75 0 0 0 0 7.5 2.26 2.26 0 0 1 2.257 2.26V54c0 2.9-2.35 5.25-5.25 5.25H12A5.25 5.25 0 0 1 6.75 54V42.01a2.26 2.26 0 0 1 2.257-2.26l.192-.005a3.75 3.75 0 0 0-.192-7.495 2.26 2.26 0 0 1-2.257-2.26V18c0-2.9 2.35-5.25 5.25-5.25zM41.5 37.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m2.56-9.56a1.5 1.5 0 0 0-2.12 0l-14 14a1.5 1.5 0 1 0 2.12 2.12l14-14a1.5 1.5 0 0 0 0-2.12M30.5 25.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9",
    clipRule: "evenodd"
  }));
}
var IcCouponH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCouponH72));

export { IcCouponH72 as I };
